<template>
<div class="chapter">
<div class="inner_page">
<div id="copy">
<p class="copy1">Published by</p>
<p class="copy">Grub Street</p>
<p class="copy">4 Rainham Close</p>
<p class="copy">London</p>
<p class="copy">SW11 6SS</p>
<p class="copy3">Copyright © Grub Street 2014</p>
<p class="copy">Copyright text © Peter Kilduff 2014</p>
<p class="copy3">ISBN-13:9781909808133</p>
<p class="copy3">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means electronic, mechanical, photocopying, recording or otherwise, without the prior permission of the copyright owner.</p>
<p class="copy3">Printed and bound by Berforts Information Press Ltd</p>
<p class="copy3">Grub Street Publishing uses only FSC (Forest Stewardship Council) paper for its books.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_copy.vue?3f41cb61